'use client';
import { useTranslations } from 'next-intl';
import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import { DrawerHeader } from 'components/pcc-components';
import { capitalizeText } from '@cat-ecom/common/utils/commonUtils';

export const SelectedEquipmentDrawerHeader = () => {
  const t = useTranslations();
  return (
    <DrawerHeader>
      <CatHeading variant="title-sm">
        <span className="u-color--Black">
          {capitalizeText(t('CURRENTLY_SHOPPING_FOR'))}
        </span>
      </CatHeading>
    </DrawerHeader>
  );
};
